import { Loader2 } from 'lucide-react';

export interface LoadingScreenProps {
  message?: string;
  /** Render inline within a section instead of taking over the full viewport. */
  fullScreen?: boolean;
}

export function LoadingScreen({ message = 'Loading…', fullScreen = true }: LoadingScreenProps) {
  return (
    <div
      className={fullScreen ? 'flex min-h-screen items-center justify-center bg-surface-page' : 'flex items-center justify-center py-12'}
      role="status"
      aria-live="polite"
    >
      <div className="text-center">
        <Loader2 className="mx-auto mb-4 h-10 w-10 animate-spin text-primary" aria-hidden="true" />
        <p className="text-sm text-text-secondary">{message}</p>
      </div>
    </div>
  );
}
